export default __webpack_public_path__ + "static/media/Profile.697fdcd2.png";